import type { IncidentOmpSummary } from '@/app/services/incident/incident.service';

export function computeOmpLossSoFar(omp: IncidentOmpSummary): number {
  return omp.assets.reduce(
    (sum, asset) => sum + (asset.dailyRevenue / 24) * asset.openHours,
    0,
  );
}

export function formatOmpDurationLabel(openHours: number): string {
  if (openHours < 24) {
    return `${Math.round(openHours)}h`;
  }

  const days = Math.floor(openHours / 24);
  return `${days}d`;
}
